import { ButtonBase, IconButton } from '@material-ui/core'
import styled from '@emotion/styled'
import { MoreHoriz } from '@material-ui/icons'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)}px;
  margin: ${({ theme }) => theme.spacing(1, 0)};
`

const Title = styled.h2`
  margin: ${({ theme }) => theme.spacing(1, 0, 0)};
  font-size: 0.95rem;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.main};
`

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)}px;
`

const Card = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  min-width: 0;
  padding: ${({ theme }) => theme.spacing(1)}px;
  border-radius: 8px;
  background-color: ${({ theme, $selected }) => (
    $selected ? theme.palette.background.paper : 'transparent')};
  color: ${({ theme, $selected }) => (
    $selected ? theme.palette.primary.main : theme.palette.icon.expandMore)};
  transition: background-color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    background-color: ${({ theme }) => theme.palette.background.paper};
  }
`

const CardTitle = styled.span`
  font-weight: 500;
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const TitleButton = styled(ButtonBase)`
  flex: 1;
  min-width: 0;
  justify-content: flex-start;
  padding: ${({ theme }) => theme.spacing(0.5)}px;
  color: inherit;
  text-align: left;

  &.Mui-focusVisible {
    outline: 2px solid currentColor;
  }
`

const MoreIcon = styled(MoreHoriz)(() => ({
  visibility: 'hidden',
}))

const MoreIconButton = styled(IconButton)({
  '&:hover .MuiSvgIcon-root': {
    visibility: 'visible',
  },
})

export {
  Container,
  Title,
  List,
  Card,
  CardTitle,
  TitleButton,
  MoreIcon,
  MoreIconButton,
}
